import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-remodelando-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <h2 className="text-2xl font-bold text-white">Remodelando PT</h2>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              A Remodelando PT é especialistas em remodelações e acabamentos em Lisboa, oferecendo serviços de qualidade com rigor e cumprimento de prazos.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-remodelando-green transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-remodelando-green transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-remodelando-green transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-remodelando-green transition-colors text-sm cursor-pointer">Home</Link></li>
              <li><Link to="/sobre" className="text-gray-400 hover:text-remodelando-green transition-colors text-sm cursor-pointer">Sobre nós</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li><Link to="/canalizacao" className="text-gray-400 hover:text-remodelando-green transition-colors text-sm cursor-pointer">Canalização</Link></li>
              <li><Link to="/remodelacao-casa-de-banho" className="text-gray-400 hover:text-remodelando-green transition-colors text-sm cursor-pointer">Remodelação de Casa de Banho</Link></li>
              <li><Link to="/pintura" className="text-gray-400 hover:text-remodelando-green transition-colors text-sm cursor-pointer">Pintura Interior e Exterior</Link></li>
              <li><Link to="/instalacao-piso-flutuante" className="text-gray-400 hover:text-remodelando-green transition-colors text-sm cursor-pointer">Instalação de Piso Flutuante</Link></li>
              <li><Link to="/reparacao-eletrica" className="text-gray-400 hover:text-remodelando-green transition-colors text-sm cursor-pointer">Reparação Elétrica</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-phone-line text-remodelando-green mt-0.5"></i>
                <a 
                  href="tel:+351927521640" 
                  onClick={() => {
                    if (typeof (window as any).gtag_report_conversion === 'function') {
                      (window as any).gtag_report_conversion();
                    }
                  }}
                  className="text-gray-400 hover:text-remodelando-green transition-colors cursor-pointer"
                >927 521 640</a>

              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-mail-line text-remodelando-green mt-0.5"></i>
                <a href="mailto:remodelandopt@gmail.com" className="text-gray-400 hover:text-remodelando-green transition-colors cursor-pointer">remodelandopt@gmail.com</a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-time-line text-remodelando-green mt-0.5"></i>
                <span className="text-gray-400">Seg–Sex, 9h–18h</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-map-pin-line text-remodelando-green mt-0.5"></i>
                <span className="text-gray-400">Calçada Chafariz, 2795-061 Linda-a-Velha, Portugal</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-xs text-gray-400">
              <Link to="/politica-privacidade" className="hover:text-remodelando-green transition-colors cursor-pointer whitespace-nowrap">Política de Privacidade</Link>
              <Link to="/politica-cookies" className="hover:text-remodelando-green transition-colors cursor-pointer whitespace-nowrap">Política de Cookies</Link>
              <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" className="hover:text-remodelando-green transition-colors cursor-pointer whitespace-nowrap">Livro de Reclamações</a>
              <Link to="/areas-atendimento" className="hover:text-remodelando-green transition-colors cursor-pointer whitespace-nowrap">Áreas de Atendimento</Link>
            </div>

          </div>


          <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} Remodelando PT. Todos os direitos reservados.</p>
            <p className="mt-2 text-sm">
              Site desenvolvido por <a href="https://wa.me/351938602478" target="_blank" rel="noopener noreferrer" className="text-remodelando-green hover:text-white transition-colors">Foture Marketing</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}